import { Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import WorkflowMainScreen from './WorkflowMainScreen';
import SamplePrompt from './SamplePrompt';
import GeneratedWorkflow from './GeneratedWorkflow';
import { useDeleteWorkflowById, useGenerateWorkflows } from '../api/workflowsApi';
import { Node } from '../types/workflow';
import { useGetNodesByWorkflowId } from '../api/nodeApi';
import { useLocation } from 'react-router-dom';

const GenerateWorkflows = () => {
  const location = useLocation();

  const [userInput, setUserInput] = useState<string[]>(location.state?.generateWorkflowInput ? [location.state.generateWorkflowInput] : []);
  const [currentInput, setCurrentInput] = useState(location.state?.generateWorkflowInput || "");
  const [shouldOpenWorkflowScreen, setShouldOpenWorkflowScreen] = useState(false);
  const [isGeneratingWorkflow, setIsGeneratingWorkflow] = useState(false);
  const [generatedWorkflowId, setGeneratedWorkflowId] = useState<string | null>(null);
  const [generatedWorkflow, setGeneratedWorkflow] = useState<Node[] | null>(null);
  const [hasDemoRun, setHasDemoRun] = useState<boolean[]>([]);
  const [loadingNewWorkflow, setLoadingNewWorkflow] = useState(false);
  const { mutate: generateWorkflows } = useGenerateWorkflows();
  const { mutate: getNodesForWorkflow } = useGetNodesByWorkflowId();
  const { mutate: deleteWorkflowById } = useDeleteWorkflowById();

  // const returnToHome = () => {
  //   setShouldOpenWorkflowScreen(false);
  //   setGeneratedWorkflow(null);
  //   setHasDemoRun([]);
  //   setLoadingNewWorkflow(false);
  //   setIsGeneratingWorkflow(false);
  // };

  const fetchAPI = useCallback((query: string) => {
    const newInput = [...userInput, query].join(' '); // Concatenate the input
    const scrollingElement = document.getElementById("generatedWorkflow");
    setTimeout(() => {
      if(scrollingElement)
        scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }, 1000);

    setGeneratedWorkflow(null);
    setLoadingNewWorkflow(true);
    setShouldOpenWorkflowScreen(true);
    setIsGeneratingWorkflow(true);
    setCurrentInput("");
    if(generatedWorkflowId) {
      deleteWorkflowById({ workflowId: generatedWorkflowId || '', hideToast: true });
    }

    generateWorkflows({ prompt: newInput }, {
      onSettled: (result) => setGeneratedWorkflowId(result?.id || ''),
    });
}, [deleteWorkflowById, generateWorkflows, generatedWorkflowId, userInput]); // Only include userInput and generateWorkflows


  useEffect(() => {
    if(generatedWorkflowId) {
      getNodesForWorkflow({ workflowId: generatedWorkflowId }, {
        onSuccess: (result) => {
          setGeneratedWorkflow(result);
        },
        onError: () => {
          setGeneratedWorkflow(null);
        },
        onSettled: () => {
          setIsGeneratingWorkflow(false);
          setLoadingNewWorkflow(false);
          setTimeout(() => {
              const scrollingElement = document.getElementById("generatedWorkflow");
              if(scrollingElement)
              scrollingElement.scrollTop = scrollingElement.scrollHeight;
          }, 500);
        }
      });
    } else {
      setIsGeneratingWorkflow(false);
      setLoadingNewWorkflow(false);
    }
  }, [generatedWorkflowId, getNodesForWorkflow])

  useEffect(() => {
    const inputData = location.state?.generateWorkflowInput;
    if(inputData) {
        setUserInput([inputData]); // Store the initial input
        window.history.replaceState({}, '');
        fetchAPI(""); // Fetch the initial workflow
    }
}, []); // Remove fetchAPI from dependencies to prevent re-runs

  return (
    <Box sx={{ display: "flex", height: "100vh", width: "100vw" }}>
      {/* {shouldOpenWorkflowScreen ?
        <Box
          sx={{
            width: 230,
            boxSizing: 'border-box',
            padding: 2,
            borderRight: "1px solid #D6D8E0"
          }}
        >
          <Box sx={{ cursor: "pointer" }} onClick={returnToHome}>
            <WorkflowLogo />
          </Box>
          <Button variant='outlined' sx={{ textTransform: "capitalize", marginTop: 3, color: "#546FFF", border: "1px solid #546FFF" }} fullWidth onClick={returnToHome}>
            <Box component={"span"} sx={{ fontSize: 18 }}>+</Box>
            <Box component={"span"} sx={{ fontWeight: 400, paddingLeft: 1, fontSize: 14, lineHeight: "18px" }}>New Workflow</Box>
          </Button>
        </Box>
        : null
      } */}
      <Box sx={{ minWidth: "calc(100% - 230px)", background: "#F8F9FA", display: "flex", flex: 1 }}>
        {shouldOpenWorkflowScreen ?
          <WorkflowMainScreen
            userPrompts={userInput}
            isGeneratingWorkflow={isGeneratingWorkflow}
            generatedWorkflow={generatedWorkflow}
            hasDemoRun={hasDemoRun}
            currentInput={currentInput}
            setCurrentInput={setCurrentInput}
            userInput={userInput}
            setUserInput={setUserInput}
            fetchAPI={fetchAPI}
          />
          : <SamplePrompt
              currentInput={currentInput}
              setCurrentInput={setCurrentInput}
              setUserInput={setUserInput}
              fetchAPI={fetchAPI}
            />
        }
        {generatedWorkflow || loadingNewWorkflow ?
            <Box sx={{ background: "#fff", borderLeft: "1px solid #D6D8E0", width: "40%" }}>
                <GeneratedWorkflow
                  generatedWorkflow={generatedWorkflow}
                  hasDemoRun={hasDemoRun}
                  setHasDemoRun={setHasDemoRun}
                  loadingNewWorkflow={loadingNewWorkflow}
                />
            </Box>
            : null
        }
      </Box>
    </Box>
  );
}

export default GenerateWorkflows;
